import React from 'react';
import PropTypes from 'prop-types';
export default class FileSize extends React.Component {
    render() {
        if (this.props.documentSizeBytes) {
            let size = parseInt(this.props.documentSizeBytes, 10);
            let sizeKb = 1000.0;
            let sizeMb = sizeKb * sizeKb;
            let sizeGb = sizeMb * sizeKb;
            let sizeTb = sizeGb * sizeKb;
            if (size < sizeMb) {
                return Math.round((size / sizeKb) * 10) / 10 + ' KB';
            }
            else if (size < sizeGb) {
                return Math.round((size / sizeMb) * 10) / 10 + ' MB';
            }
            else if (size < sizeTb) {
                return Math.round((size / sizeGb) * 10) / 10 + ' GB';
            }
        }
        return '';
    }
}
FileSize.propTypes = {
    documentSizeBytes: PropTypes.any,
};
